






































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { EntityId } from '@/api/types'
import { Preset } from '~/api/types'
import TegPropertySearchBox from '~/components/PropertySearchBox.vue'
import Atoms from '~/components/Atoms.vue'

@Component({
  components: {
    'property-search-box': TegPropertySearchBox,
    Atoms,
  },
})
export default class TegSetup extends Vue {
  private properties: EntityId[] = []
  private maxCounterexamples: number = 5
  private presets: Preset[] = [
    // { description: 'empty',
    //   properties: [],
    // },
    { description: 'Countries & Borders',
      properties: ['P17', 'P30', 'P47'],
    },
    { description: 'Credit Cards',
      properties: ['P4443', 'P137', 'P2555'],
    },
    {
      description: 'Use of Energy',
      properties: ['P618', 'P366'],
    },
    { description: 'Memory & Computation',
      properties: ['P880', 'P2928'],
    },
    { description: 'Space launches',
      properties: ['P619', 'P620'],
    },
  ]

  private onSelectedPreset(preset: Preset) {
    this.properties = preset.properties
  }

  private onSelectedProperty(propertyId: EntityId) {
    if (!this.properties.includes(propertyId)) {
      this.properties.push(propertyId)
    }
  }

  private onRemove(propertyId: EntityId) {
    this.properties = this.properties.filter((elt) => elt !== propertyId)
  }

  private onStartGame() {
    const properties = this.properties
    const maxCounterexamples = this.maxCounterexamples

    this.$emit('start-game', { properties,
                               maxCounterexamples,
                             })

  }
}
